<template>
    <div class="home">
        <h1 class="center">
            Hello and welcome to my Artpage<br />
            <br />
            LunArtic
        </h1>
        <br />
        <p class="blocksatz_c">
            I'am an italian / german artist, who loves to combine and to experiment different media and styles.
            So you will find individual categories to explore. Feel free to contact me if you are interested to buy a piece of art or for feedback.
            <br />
            <br />
            email: <a href="mailto:lunartic.online@gmail.com">lunartic.online@gmail.com</a><br />
            instagram: <a href="https://www.instagram.com/lunartic.kleiner_mond/" target="_blank">lunartic.kleiner_mond</a><br />
            <br />
            Enjoy my Artpage and have a nice day
            <br />
            Best regards<br />
            <br />
            Lorena Lunetta
        </p>
    </div>
</template>

<script>
    import store from "@/store";
    export default {
        name: 'Home',
        data: function () {
            return {
                store: store
            };
        },
        components: {
        }
    }
</script>

<style scoped>
    a {
        font-weight: bold;
        text-decoration: underline;
    }

    a:hover {
        text-decoration: none;
    }

    p {
        font-size: 26px;
        line-height: 34px;
    }

    @media screen and (max-width: 768px) {
        p {
            font-size: 22px;
            line-height: 30px;
        }
    }

    .center {
        text-align: center;
    }

    .blocksatz_c {
        hyphens: auto;
        text-align: justify; /* f�r Edge */
        -moz-text-align-last: center; /* f�r Firefox vor 58.0 */
        text-align-last: center;
        max-width: 1024px;
        margin: 0 auto;
    }
</style>
